var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecordHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0711 5.98959C19.364 5.6967 19.364 5.22183 19.0711 4.92893C15.1658 1.02369 8.83418 1.02369 4.92893 4.92893C1.02369 8.83418 1.02369 15.1658 4.92893 19.0711C5.22183 19.364 5.6967 19.364 5.98959 19.0711C6.28249 18.7782 6.28249 18.3033 5.98959 18.0104C2.67014 14.691 2.67014 9.30905 5.98959 5.98959C9.30905 2.67014 14.691 2.67014 18.0104 5.98959C18.3033 6.28249 18.7782 6.28249 19.0711 5.98959ZM12 5.5C12.3797 5.5 12.6935 5.78215 12.7432 6.14823L12.75 6.25V12.282L16.5045 15.695C16.7831 15.9483 16.8271 16.3634 16.6235 16.667L16.555 16.7545C16.3017 17.0331 15.8866 17.0771 15.583 16.8735L15.4955 16.805L11.4955 13.1686C11.3652 13.0501 11.2816 12.8905 11.2573 12.7182L11.25 12.6136V6.25C11.25 5.83579 11.5858 5.5 12 5.5ZM20.0198 7.33025C20.3935 7.15144 20.8413 7.30937 21.0201 7.683C21.6637 9.02778 22 10.5021 22 12.0001C22 14.6522 20.9464 17.1958 19.071 19.0711C16.0485 22.0937 11.476 22.8383 7.68196 21.0226C7.30833 20.8437 7.1504 20.3959 7.32921 20.0223C7.50803 19.6486 7.95587 19.4907 8.3295 19.6695C11.5541 21.2127 15.4411 20.5798 18.0104 18.0105C19.6044 16.4164 20.5 14.2544 20.5 12.0001C20.5 10.7268 20.2142 9.47366 19.6671 8.33054C19.4883 7.95691 19.6462 7.50907 20.0198 7.33025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordHover);
export default __webpack_public_path__ + "static/media/recordHover.e8af64ce64d885d9d0a031634782164a.svg";
export { ForwardRef as ReactComponent };